import React from 'react';
import { NamedLink } from '../../../components';
import { useIntl } from '../../../util/reactIntl';
import SearchResultsPanel from '../../SearchPage/SearchResultsPanel/SearchResultsPanel';

import css from './Sections.module.css';

function PopularMoorage(props) {
  const { listings } = props;

  const intl = useIntl();

  const title = intl.formatMessage({ id: 'PopularMoorage.title' });
  const viewAllMoorage = intl.formatMessage({ id: 'PopularMoorage.viewAllMoorage' });

  return (
    <div className={css.popularMoorage}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{title}</h2>
          </div>
          <div className={css.rightSec}>
            <NamedLink name="SearchPage">{viewAllMoorage}</NamedLink>
          </div>
        </div>
      </div>
      <div className={css.contentWidth}>
        <SearchResultsPanel listings={listings} isMapVariant={false} isLandingPopularGrid />
      </div>
    </div>
  );
}

export default PopularMoorage;
